import { PageLoaderModule } from './page-loader/page-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerModule } from './container/container.module';
import { ErrNoDataModule } from './err-no-data/err-no-data.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, ContainerModule, ErrNoDataModule, PageLoaderModule],
    exports: [ContainerModule, ErrNoDataModule, PageLoaderModule],
})
export class IncPageModule { }
